import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CancelCrossIcon, Sheet } from "@activecollab/components";
import PropTypes from "prop-types";
import { CalendarEvent } from "~/components/CalendarEvent/CalendarEvent";
import ErrorBoundary from "~/components/ErrorBoundry";
import { useObjectSheetContext } from "~/components/Sheet/ObjectSheetContext";
import { CalendarEventRescheduleContext } from "../CalendarEvent/CalendarEventRescheduleContext";
import { CalendarEventResolver } from "../CalendarEvent/CalendarEventResolver";

export const CalendarEventSheet = React.forwardRef(({ id, calendarId, occurrence, open, onClose }, ref) => {
  const { t } = useTranslation();

  const { closeSheet } = useObjectSheetContext();

  const controls = useMemo(
    () => [
      {
        tooltip: t("Close"),
        onClick: closeSheet,
        icon: <CancelCrossIcon />,
      },
    ],
    [closeSheet, t]
  );

  return (
    <CalendarEventRescheduleContext source="sheet">
      <Sheet
        ref={ref}
        open={open}
        position="right"
        animation="right"
        mode="stretch"
        onClose={onClose}
        className="calendar-event-container"
        controls={controls}
      >
        <ErrorBoundary errorLocation="CalendarEventSheet">
          <CalendarEventResolver
            id={id}
            calendarId={calendarId}
          >
            <CalendarEvent
              id={id}
              occurrence={occurrence}
            />
          </CalendarEventResolver>
        </ErrorBoundary>
      </Sheet>
    </CalendarEventRescheduleContext>
  );
});

CalendarEventSheet.propTypes = {
  id: PropTypes.number.isRequired,
  calendarId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  occurrence: PropTypes.number,
  onClose: PropTypes.func,
};

CalendarEventSheet.displayName = "CalendarEventSheet";
